'use client';

import React from 'react';
import { ExperienceType } from '../types';
import { typography } from '@/design-system/tokens/typography';
import Border from '../../common/border';

interface ExperienceWhatToExpectProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceWhatToExpect: React.FC<ExperienceWhatToExpectProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const getWhatToExpect = () => {
    const exp = experience as {
      whatToExpect?: Array<{ title?: string; description?: string }>;
      expectations?: Array<{ title?: string; description?: string }>;
    };
    return exp?.whatToExpect || exp?.expectations || [];
  };

  const whatToExpect = getWhatToExpect();

  if (!Array.isArray(whatToExpect) || whatToExpect.length === 0) return null;

  return (
    <div className='space-y-4'>
      <h2
        className='font-semibold text-gray-900'
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        What to Expect
      </h2>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
        {whatToExpect.map((item, index) => (
          <div key={index} className='flex flex-col p-4 bg-gray-50 rounded-lg'>
            <div className='w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mb-3'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                className='text-blue-600'
              >
                <path
                  d='M10 2.5L12.5 7.5L10 12.5L7.5 7.5L10 2.5Z'
                  stroke='currentColor'
                  strokeWidth='1.5'
                />
              </svg>
            </div>
            {item.title && (
              <h3 className='text-sm font-semibold text-gray-900 mb-1'>
                {item.title}
              </h3>
            )}
            {item.description && (
              <p className='text-xs text-gray-600'>{item.description}</p>
            )}
          </div>
        ))}
      </div>
      <div className='pt-4'>
        <Border />
      </div>
    </div>
  );
};
